var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestCreditLogoNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 203 33",
    viewBox: "0 0 203 33",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00F783;}\n\t.st1{fill:#FFFFFF;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m0.7 24.4 12.9 8.1c0.6 0.3 1.1 0.3 1.7 0l9.8-5.2 7.4 4.6v-7.1s-1.6-1-3.7-2.3v-21.7c0-0.4-0.3-0.7-0.7-0.7h-27.3c-0.4-0.1-0.8 0.3-0.8 0.7v22.1c0 0.7 0.2 1 0.7 1.5zm5.6-4.6v-13.3c0-0.2 0.2-0.4 0.4-0.4h15.4c0.2 0 0.4 0.2 0.4 0.4v11.8c-4.3-2.7-8.2-5.2-8.3-5.2v7.1l4.5 2.8-4 1.9c-0.3 0.2-0.6 0.2-0.9 0l-7.4-4.8c-0.1 0-0.1-0.1-0.1-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m74.4 17.7c0 2.8-1.5 3.9-3.5 3.9-1.8 0-3.1-1.1-3.1-3.3v-9.2l-4.1 2v7.8c0 4.2 2.6 6.6 6 6.6 2.1 0 3.8-0.8 4.7-2.2v1.7h4.1v-15.9l-4.1 2v6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m89 8.7c-5 0-8.4 3.7-8.4 8.4s3.4 8.4 8.7 8.4c3 0 5.4-1.2 6.9-3.4l-3.2-2c-0.7 0.9-2 1.6-3.6 1.6-2.2 0-3.9-0.9-4.5-3h12c0.1-0.5 0.2-1.1 0.2-1.7 0-4.6-3.4-8.3-8.1-8.3zm-4.1 6.9c0.5-2 2-3.2 4.2-3.2 1.7 0 3.4 0.9 3.9 3.2h-8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m102.8 13.6c0-0.9 0.8-1.3 1.8-1.3 1.2 0 2.1 0.6 2.5 1.6l3.5-1.9c-1.2-2.2-3.5-3.4-6-3.4-3.3 0-6 1.8-6 5.1 0 5.6 8.2 4.3 8.2 6.6 0 0.9-0.9 1.4-2.2 1.4-1.6 0-2.7-0.8-3.1-2.1l-3.6 2c1.1 2.4 3.5 3.8 6.7 3.8 3.4 0 6.4-1.7 6.4-5.1 0-5.8-8.2-4.3-8.2-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.8,3.8l-4.1,1.9v14.1c0,4.3,3,6,8.7,5.3v-3.7c-2.4,0.1-4.6,0.1-4.6-1.6v-6.6h4.6V9.3h-4.6V3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m60.9 14c0-6.5-5.1-11.6-11.6-11.6-6.4 0-11.5 5.1-11.5 11.6s5.1 11.6 11.5 11.6c3 0 5.7-1.1 7.7-2.9l4.8 2.8v-4.8s-0.9-0.5-2.2-1.3c0.8-1.7 1.3-3.5 1.3-5.4zm-11.6 7.2c-4 0-7.2-3-7.2-7.3s3.1-7.3 7.2-7.3 7.2 3 7.2 7.3c0 1.1-0.2 2.2-0.6 3.1-3.3-2-6.7-4-6.7-4v4.8l3.9 2.3c-1.1 0.8-2.4 1.1-3.8 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m123.9 14.6c0-6 4.6-10.9 11-10.9 3.9 0 7.3 2 9.1 5.2l-1.9 1.1c-1.3-2.5-4.1-4.2-7.2-4.2-5.3 0-8.9 3.9-8.9 8.8s3.6 8.8 8.9 8.8c3.1 0 5.9-1.7 7.2-4.2l1.9 1.1c-1.7 3.1-5.2 5.2-9.1 5.2-6.5-0.1-11-4.9-11-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m153.1 9.8v1.9c-2.4 0-4.7 1.3-4.7 5v8.3h-2v-15h2v2.5c1-2 2.8-2.7 4.7-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m168.5 17.6c0 0.3 0 0.6-0.1 0.9h-13.2c0.4 3.1 2.8 5 6 5 2.4 0 4-1.1 4.8-2.5l1.7 1c-1.3 2-3.6 3.5-6.6 3.5-4.7 0-8-3.3-8-7.9 0-4.4 3.2-7.9 7.8-7.9 4.8 0 7.6 3.8 7.6 7.9zm-13.2-1h11.2c-0.4-3.3-2.8-5-5.4-5-3.2 0-5.4 2.1-5.8 5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m185.8 4.1v21h-2v-2.9c-1.3 2-3.4 3.3-6.1 3.3-4.2 0-7.7-3.4-7.7-7.9 0-4.4 3.5-7.9 7.7-7.9 2.7 0 4.8 1.3 6.1 3.3v-8.9h2zm-2 13.5c0-3.3-2.6-5.9-5.9-5.9s-5.9 2.6-5.9 5.9 2.6 5.9 5.9 5.9 5.9-2.6 5.9-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m188.8 5.5c0-0.8 0.6-1.4 1.4-1.4s1.4 0.7 1.4 1.4c0 0.8-0.6 1.4-1.4 1.4s-1.4-0.7-1.4-1.4zm0.4 4.6h2v15h-2v-15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m198.3 12v9.1c0 2.6 1.4 2.4 4.3 2.2v1.7c-4 0.6-6.3-0.4-6.3-4v-9h-3.2v-1.9h3.2v-3.6l2-0.6v4.2h4.3v1.9h-4.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestCreditLogoNew);
export default __webpack_public_path__ + "static/media/quest-credit-logo-new.793184b548da142209a496d64d46c725.svg";
export { ForwardRef as ReactComponent };